<template functional>
    <router-link
        class="o-videoshop-grid-item"
        tag="button"
        :to="{ name: 'terminal.movie.details', query: { movieId: props.movieId, cinemaId: props.cinemaId }}"
    >
        <div class="videoshop-grid-item-poster">
            <img 
                :src="props.poster"
                class="videoshop-grid-item-image"
            >
        </div>
        <span class="videoshop-grid-item-title">
            {{ props.title }}
        </span>
    </router-link>
</template>

<script>
export default {
    name: "OVideoShopGridItem",
    props: {
        title: {
            type: String,
            default: ''
        },
        poster: {
            type: String,
            default: ''
        },
        movieId: {
            type: String,
            required: true
        },
        cinemaId: {
            type: Number,
            required: true
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />